module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_j_normal.cd33725e.png";